var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderPlace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 71,
    viewBox: "0 0 549 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.406 411.652L529.529 414.967C541.553 433.761 548.615 456.04 548.615 480.006C548.615 503.973 541.553 526.246 529.529 545.043L527.406 548.367L264.943 960H0.385742L438.658 272.466L527.406 411.652Z",
    fill: "url(#paint0_linear_5845_34136)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527.406 548.351L529.529 545.033C541.553 526.236 548.615 503.963 548.615 479.996C548.615 456.03 541.553 433.751 529.529 414.957L527.406 411.642L264.943 0.000762939H0.385742L438.658 687.536L527.406 548.351Z",
    fill: "#009BE2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5845_34136",
    x1: -54.0774,
    y1: 874.579,
    x2: 569.189,
    y2: 477.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83D1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692716,
    stopColor: "#0376AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADEE7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderPlace);
export default __webpack_public_path__ + "static/media/loader-place.3b9333de436feac1a6d06ca391e571d6.svg";
export { ForwardRef as ReactComponent };